import axios, { AxiosResponse } from "axios"
import { RemesaDeFacturaCreationDtoProps } from "./DTOs/RemesaDeFacturaCreationDto"

export async function createRemesaDeFactura(
  data: RemesaDeFacturaCreationDtoProps
): Promise<AxiosResponse> {
  const resp = await axios.post(`/RemesaDeFactura`, data)
  return resp
}
